import { postData } from "../apiClient";

// Login API function - handles user authentication
export const loginUser = async (email, password) => {
    try {
        const result = await postData('/auth/login', {
            email,
            password
        });

        return result;
    } catch (error) {
        console.error('Login API error:', error);
        throw error;
    }
};